/* src/app/builder-screen-beta/json-editor/json-editor.component.scss */
.json-editor-container {
  display: flex;
  flex-direction: column;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  background: #fff;
  overflow: hidden;
  position: relative;
}
.json-editor-container .json-editor-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background: #fafafa;
  border-bottom: 1px solid #f0f0f0;
  min-height: 40px;
}
.json-editor-container .json-editor-toolbar .toolbar-left {
  display: flex;
  gap: 8px;
  align-items: center;
}
.json-editor-container .json-editor-toolbar .toolbar-left .validation-status {
  margin: 0;
}
.json-editor-container .json-editor-toolbar .toolbar-left .editor-mode-indicator {
  margin: 0;
  animation: pulse 1.5s ease-in-out infinite alternate;
}
.json-editor-container .json-editor-toolbar .toolbar-right {
  display: flex;
  gap: 4px;
  align-items: center;
}
.json-editor-container .json-editor-toolbar .toolbar-right button {
  display: flex;
  align-items: center;
  justify-content: center;
}
.json-editor-container .validation-error {
  padding: 8px 12px;
  background: #fff2f0;
  border-bottom: 1px solid #ffccc7;
}
.json-editor-container .validation-error ::ng-deep .ant-alert {
  margin-bottom: 0;
}
.json-editor-container .editor-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 200px;
  background: #fafafa;
}
.json-editor-container .ace-editor {
  flex: 1;
  width: 100%;
  font-family:
    "Monaco",
    "Menlo",
    "Ubuntu Mono",
    "Consolas",
    "source-code-pro",
    monospace;
  font-size: 14px;
  line-height: 1.5;
  border: none;
  outline: none;
  transition: all 0.3s ease;
}
.json-editor-container .ace-editor.editor-error {
  border-left: 3px solid #ff4d4f;
}
.json-editor-container .ace-editor.editor-readonly {
  background-color: #f5f5f5;
}
.json-editor-container .ace-editor ::ng-deep .ace_gutter {
  background: #f8f9fa;
  color: #6c757d;
  border-right: 1px solid #e9ecef;
}
.json-editor-container .ace-editor ::ng-deep .ace_gutter-active-line {
  background-color: #e3f2fd;
}
.json-editor-container .ace-editor ::ng-deep .ace_marker-layer .ace_active-line {
  background: rgba(0, 123, 255, 0.1);
}
.json-editor-container .ace-editor ::ng-deep .ace_cursor {
  color: #1890ff;
}
.json-editor-container .ace-editor ::ng-deep .ace_selection {
  background: rgba(24, 144, 255, 0.2);
}
.json-editor-container .ace-editor ::ng-deep .ace_string {
  color: #52c41a;
}
.json-editor-container .ace-editor ::ng-deep .ace_constant.ace_numeric {
  color: #1890ff;
}
.json-editor-container .ace-editor ::ng-deep .ace_constant.ace_language {
  color: #722ed1;
}
.json-editor-container .ace-editor ::ng-deep .ace_keyword {
  color: #fa541c;
}
.json-editor-container .ace-editor ::ng-deep .ace_variable {
  color: #13c2c2;
}
.json-editor-container .ace-editor ::ng-deep .ace_error {
  background-color: rgba(255, 77, 79, 0.1);
  border-bottom: 1px dotted #ff4d4f;
}
.json-editor-container .ace-editor ::ng-deep .ace_warning {
  background-color: rgba(250, 173, 20, 0.1);
  border-bottom: 1px dotted #faad14;
}
.json-editor-container .json-editor-footer {
  padding: 6px 12px;
  background: #fafafa;
  border-top: 1px solid #f0f0f0;
  font-size: 12px;
  color: #8c8c8c;
}
.json-editor-container .json-editor-footer .footer-info {
  display: flex;
  gap: 16px;
  align-items: center;
}
.json-editor-container .json-editor-footer .footer-info .info-item {
  display: flex;
  align-items: center;
  gap: 4px;
}
.json-editor-container .json-editor-footer .footer-info .info-item nz-icon {
  font-size: 12px;
}
@keyframes pulse {
  from {
    opacity: 1;
  }
  to {
    opacity: 0.6;
  }
}
@media (max-width: 768px) {
  .json-editor-container .json-editor-toolbar {
    flex-direction: column;
    gap: 8px;
    align-items: flex-start;
  }
  .json-editor-container .json-editor-toolbar .toolbar-left,
  .json-editor-container .json-editor-toolbar .toolbar-right {
    width: 100%;
    justify-content: flex-start;
  }
  .json-editor-container .json-editor-footer .footer-info {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
}
.json-editor-container.dark-theme {
  background: #141414;
  border-color: #434343;
}
.json-editor-container.dark-theme .json-editor-toolbar {
  background: #1f1f1f;
  border-bottom-color: #434343;
}
.json-editor-container.dark-theme .validation-error {
  background: #2a1215;
  border-bottom-color: #a8071a;
}
.json-editor-container.dark-theme .json-editor-footer {
  background: #1f1f1f;
  border-top-color: #434343;
  color: #8c8c8c;
}
.json-editor-container.dark-theme .ace-editor.editor-readonly {
  background-color: #262626;
}
.json-editor-container:focus-within {
  border-color: #1890ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
}
.json-editor-container.size-small .ace-editor {
  font-size: 12px;
}
.json-editor-container.size-small .json-editor-toolbar {
  padding: 6px 8px;
  min-height: 32px;
}
.json-editor-container.size-large .ace-editor {
  font-size: 16px;
}
.json-editor-container.size-large .json-editor-toolbar {
  padding: 12px 16px;
  min-height: 48px;
}
/*# sourceMappingURL=json-editor.component.css.map */
